
import { mapGetters } from "vuex"

export default {
  data: () => ({
    isBackVisible: false,
  }),

  computed: {
    ...mapGetters("app", ["historyLen"]),
  },

  mounted () {
    // https://stackoverflow.com/questions/62358716/check-if-there-is-a-previous-page-in-vue-route
    this.isBackVisible = ((window?.history?.length ?? 0) - this.historyLen) > 0
  },
}
